export const EnvironmentsStorageKey = 'environments';
export const ConfigurationStorageKey = 'configuration';
export const EnvironmentIdStorageKey = 'appAdtUrl';
export const AdtExplorerTenantIdStorageKey = 'adtExplorerTenantId';
export const ThemeStorageKey = 'flightsTheme';
export const LanguageStorageKey = 'i18nextLng';
export const AdtBlobContainerURLStorageKey = 'adtBlobContainerURL';
export const AdtBlobContainerURLsStorageKey = 'adtBlobContainerURLs';
export const TenantIdURLParamKey = 'tid';
export const EnvironmentIdURLParamKey = 'eid';
export const TwinIdURLParamKey = 'twinId';
export const BlobContainerURLParamKey = 'containerUrl';
export const ScenesFreHasBeenSeenKey = 'hasSeen3DScenesFRE';

export const LOCAL_STORAGE_KEYS = {
    FeatureFlags: {
        Telemetry: {
            debugLogging: '3DScenes.debug.telemetryLogging', // enables debug logging for all emitted telemetry events
            forceDevTelemetryEndpoint: '3DScenes.debug.forceDevAppInsights' // forces the app to send data to the dev application insights instance      
        }
    }
};
